<template>
  <div class="service-wrap">
    <h1 class="user-center-h1">{{$t('upgrade_page_views_wallet_index_681')}}</h1>
    <div v-if="accountInfo" class="account_content">
      <div class="card-wrap">
        <span class="first-child">{{$t('upgrade_page_views_wallet_index_682')}}</span>
        <img class="gold-icon" src="~@/assets/image/icons/gold-icon.png" />
        <span class="balance-count">{{ accountInfo.balance }}</span>
        <button class="service-btn" @click="recharge">{{$t('components_recharge_index_389')}}</button>
      </div>
      <div class="card-wrap">
        <span class="first-child">{{$t('upgrade_page_views_wallet_index_683')}}</span>
        <img class="gold-icon" src="~@/assets/image/icons/diamond.png" />
        <span class="balance-count">{{ accountInfo.diamondBalance }}</span>
        <button class="service-btn" @click="payDiamond">{{$t('upgrade_page_views_wallet_index_684')}}</button>
        <el-dialog
          :title="$t('upgrade_page_views_diamond_recharge_diamond_dialog_419')"
          :visible.sync="isPayDialog"
          width="400px"
          append-to-body
          center
          destroy-on-close
        >
          <div class="diamond-pay">
            <div class="diamond-transition">
              <span
                >{{$t('components_sendgifts_index_425')}}<img src="~@/assets/image/icons/coin.png" alt=""
              /></span>
              =
              <span>{{$t('components_sendgifts_index_426', [ isConvertRatioFloor ])}}<img
                  src="~@/assets/image/icons/diamond.png"
                  alt=""
              /></span>
            </div>
            <div class="diamond-pay-box">
              <el-input
                v-model.number="inputNicee"
                type="text"
                maxlength="10"
                clearable
              >
                <img slot="prefix" src="~@/assets/image/icons/coin.png" />
              </el-input>
              <el-input
                v-model="inputDiamond"
                type="number"
                maxlength="12"
                :disabled="true"
              >
                <img slot="prefix" src="~@/assets/image/icons/diamond.png" />
              </el-input>
            </div>
            <div class="pay-num">
              <span>{{$t('components_sendgifts_index_427')}}</span
              ><span class="pay-num-item">{{ inputNicee }}</span
              ><img src="~@/assets/image/icons/coin.png" alt="" />
            </div>
            <div>
              <el-button>{{$t('upgrade_page_layout_header_42')}}</el-button>
              <el-button @click="onClickPay" :disabled="!inputNicee"
                >{{$t('upgrade_page_views_diamond_recharge_diamond_dialog_421')}}</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div>

      <div class="card-wrap">
        <span class="first-child">{{$t('upgrade_page_layout_header_22')}}</span>
        <span v-if="canuseCoupon" class="coupons-count"
          >{{$t('upgrade_page_views_wallet_index_685', [ canuseCoupon ])}}</span
        >
        <span v-else class="coupons-count">{{$t('upgrade_page_views_order_components_coupons_info_325')}}</span>
        <button class="service-btn" @click="jumpCoupon">{{$t('upgrade_page_views_wallet_index_686')}}</button>
      </div>
    </div>
    <div class="following-water">
      <div class="select-balance-type">
        <div class="type-title">{{$t('upgrade_page_views_wallet_index_687')}}<el-select v-model="transactionType" @change="changeTransactionType">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="buttons">
          <div
            :class="[
              'pointer',
              !showSettlement && 'active',
              { 'is-diamond': isDiamond }
            ]"
            @click="showSettlement = false"
          >{{$t('upgrade_page_views_wallet_index_688')}}</div>
          <div
            :class="['pointer', showSettlement && 'active']"
            @click="showSettlement = true"
            v-show="!isDiamond"
          >{{$t('upgrade_page_views_wallet_index_689')}}</div>
        </div>
      </div>
      <div class="service-msg" :class="{ 'is-Diabond': isDiamond }">
        <p class="service-msg-1">{{$t('upgrade_page_views_wallet_index_690')}}</p>
        <p class="service-msg-2">{{$t('upgrade_page_views_wallet_index_691')}}</p>
        <p class="service-msg-3">
          {{ isDiamond ? $t('upgrade_page_views_wallet_index_683') : $t('upgrade_page_views_wallet_index_692') }}
        </p>
        <p class="service-msg-4">{{$t('upgrade_page_views_wallet_index_693')}}</p>
        <p class="service-msg-5">{{$t('upgrade_page_views_wallet_index_694')}}</p>
        <!-- <p class="service-msg-6" v-if="!isDiamond">禮物收入</p> -->
      </div>
      <div class="service-list">
        <template v-if="!isDiamond">
          <accountCard
            v-for="(item, index) in serveList"
            :key="index"
            :serveObj="item"
            :is-settlement="showSettlement"
          />
        </template>
        <template v-else>
          <diabondAccountCard
            v-for="(item, index) in serveList"
            :key="index"
            :serveObj="item"
            :is-settlement="showSettlement"
          />
        </template>
        <div
          v-if="showSettlement ? isSettlementLoading : isLoading"
          class="loading-line"
        >
          <i class="el-icon-loading" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import accountCard from '@/components/AccountCard/index';
import diabondAccountCard from '@/components/AccountCard/diabond-account-card.vue';

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      inputNicee: 0,
      isPayDialog: false,
      options: [
        {
          value: 'Bill',
          label: i18n.t('upgrade_page_views_wallet_index_695')
        },
        {
          value: 'DiamondBill',
          label: i18n.t('upgrade_page_views_wallet_index_683')
        }
      ],
      // 交易類型
      transactionType: 'Bill',
      serveList: [],
      activeScreen: '',
      lastUid: '',
      requestQuery: {
        lastItemUuid: null,
        offset: 10
      },
      deductList: [],
      isLoading: false,
      isFinish: false,
      showSettlement: false,
      isSettlementLoading: false
    };
  },
  computed: {
    isConvertRatioFloor() {
      return Math.floor(this.accountInfo.convertRatio);
    },
    inputDiamond() {
      return this.accountInfo.convertRatio
        ? this.inputNicee * this.isConvertRatioFloor
        : 0;
    },
    ...mapGetters(['userInfo', 'accountInfo']),
    canuseCoupon() {
      return this.accountInfo && this.accountInfo.couponInfoList
        ? this.accountInfo.couponInfoList.filter(
            item => item.couponStatus === 'EFFECT'
          ).length
        : 0;
    },
    // 交易明細是否是鑽石
    isDiamond() {
      return this.transactionType === 'DiamondBill';
    }
  },
  watch: {
    showSettlement(value) {
      this.serveList = [];
      if (!value) {
        this.isFinish = false;
        window.addEventListener('scroll', this.listenWindowScroll);
        this.requestQuery = {
          lastItemUuid: null,
          offset: 10,
          statementReceiptKind: this.transactionType
        };
      } else {
        window.removeEventListener('scroll', this.listenWindowScroll);
      }
      this.toGetList();
    }
  },
  components: {
    accountCard,
    diabondAccountCard
  },
  created() {
    window.addEventListener('scroll', this.listenWindowScroll);
    this.toGetList();
    this.getCouponsList();
    this.activeScreen = 'Details';
    console.log(',,,', this.transactionType);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.listenWindowScroll);
  },
  methods: {
    onClickPay() {
      if (!this.userInfo) {
        this.$util.Login();
      } else if (this.inputNicee <= this.accountInfo.balance) {
        this.$http
          .post('/account/convertAccount', {
            accountKind: 'Balance',
            convertAccountKind: 'Diamond',
            convertAmount: this.inputNicee,
            userUuid: this.userInfo.uuid
          })
          .then(() => {
            this.$store.dispatch('app/getUserAccount');
          });
        this.inputNicee = 0;
        this.isPayDialog = false;
      } else {
        this.$confirm({
          content: i18n.t('components_sendgifts_index_434', [this.accountInfo.balance]),
          confirmButtonText: i18n.t('upgrade_page_views_order_components_submit_button_365'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.isPayDialog = false;
          this.recharge();
        });
      }
    },
    payDiamond() {
      this.inputNicee = 0;
      this.isPayDialog = true;
    },
    jumpCoupon() {
      this.$router.push({
        path: '/coupons'
      });
    },
    getDeduct() {
      // 登录情况下获取抽成信息
      this.$http.get('/account/stolen/content').then(({ data }) => {
        this.deductList = data.split(/\n/).filter(item => item.trim() !== '');
      });
    },
    recharge() {
      if (this.userInfo) {
        this.$router.push({
          name: 'Saving'
        });
      } else {
        this.$util.Login().then(() => {
          this.$router.push({
            name: 'Saving'
          });
        });
      }
    },
    // 結算中明細列表
    getSettlementingList() {
      if (this.isSettlementLoading) return;
      this.isSettlementLoading = true;
      // 帳户结算中列表
      this.$http
        .get('/settlement/list')
        .then(({ data }) => {
          this.isSettlementLoading = false;
          this.serveList = data;
        })
        .catch(() => {
          this.isSettlementLoading = false;
        });
    },
    toGetList() {
      if (this.showSettlement) {
        this.getSettlementingList();
      } else {
        this.getList();
      }
    },
    listenWindowScroll() {
      const pageContentHeight = document.body.scrollHeight;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = document.documentElement.clientHeight;

      // const { dataEnd, isLoading } = this
      console.log('test');
      if (
        pageContentHeight - windowHeight - scrollTop < 100 &&
        !this.isLoading &&
        !this.isFinish
      ) {
        this.getMoreMasterList();
      }
    },
    getMoreMasterList() {
      this.requestQuery.lastItemUuid = this.serveList.length
        ? this.serveList[this.serveList.length - 1].statementNo
        : null;
      this.getList();
    },
    // 收支明細列表
    getList() {
      var params = Object.assign({}, this.requestQuery);
      this.isLoading = true;
      // 帳戶管理列表
      this.$http
        .get('/account/statement/list', {
          ...params,
          statementReceiptKind: this.transactionType
        })
        .then(({ data }) => {
          if (data && Array.isArray(data.pageContent)) {
            const Arr = data.pageContent.map(item => {
              if (item.receiptKind.indexOf('Out') > -1) {
                item.receiptKind = i18n.t('upgrade_page_views_wallet_index_696');
                item.amount = '-' + item.amount;
              } else if (item.receiptKind.indexOf('In') > -1) {
                item.receiptKind = this.transactionType == 'DiamondBill' ?'鑽石收入':i18n.t('upgrade_page_views_wallet_index_697');
                item.amount = '+' + item.amount;
              }

              return item;
            });

            this.serveList = params.lastItemUuid
              ? this.serveList.concat(Arr)
              : Arr;
            this.isFinish = data.pageContent.length < this.requestQuery.offset;
          }

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.isFinish = true;
        });
    },
    changeTransactionType() {
      if (this.transactionType === 'DiamondBill') {
        this.showSettlement = false;
      }
      this.toGetList();
    },
    screenAccount() {
      //點擊我的紅包
    },
    withdrawal() {
      this.$router.push({
        path: '/withdraw'
      });
    },
    transBalance() {
      this.$router.push({
        name: 'transferBalance'
      });
    },
    /**
     * @description: 获取用户優惠券
     */
    getCouponsList() {
      this.$http
        .post('coupon/getUserCouponInfo', {
          couponStatusList: ['EFFECT'],
          userUuid: this.userInfo.uuid
        })
        .then(data => {
          if (data && data.data && data.msg === 'success') {
            this.couponsList = data.data;
          }
        });
    },
    gotoCoupons() {
      this.$router.push('/coupons');
    }
  }
};
</script>

<style lang="scss" scoped>
.following-water {
  @include whiteBox;
  margin-bottom: 50px;
  padding-bottom: 18px;
  .select-balance-type {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 71px;
    border-bottom: 1px solid $color-split;
    padding: 0 28px;
    .type-title {
      /deep/ .el-input__inner {
        height: 30px;
        line-height: 30px;
        width: 100px;
      }
    }
    .buttons {
      @include flex;
      .is-diamond {
        border-radius: 6px !important;
      }
      > div {
        padding: 0 16px;
        height: 32px;
        line-height: 32px;
        font-size: 13px;
        color: $color-gray-2;
        border: 1px solid $color-split;
        &:first-child {
          border-radius: 6px 0 0 6px;
          border-right: none;
        }
        &:last-child {
          border-radius: 0 6px 6px 0;
          border-left: none;
        }
        &.active {
          color: #fff;
          font-weight: 500;
          background: $color-gray-2;
          border: none;
        }
      }
    }
  }
}
.service-list {
  min-height: 300px;
  margin: 0 28px;
  .loading-line {
    text-align: center;
    padding-top: 20px;
    font-size: 25px;
  }
}
.settlement-tips-popover {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  .strong {
    font-weight: 600;
    color: #333;
  }

  p {
    color: #333;
  }
}

.account-btn {
  border-radius: 5px;
  margin-right: 28px;
  margin: 20 10 24 0;
  background: none;
  font-weight: 500;
  font-size: 22px;
  line-height: 31px;
  color: #333333;
  // cursor: pointer;
  // &:hover {
  //   color: #ff891e;
  // }
}
// .select-screen {
//   color: #ff891e;
// }
.add-account {
  width: 100%;
  padding: 20px 30px;
  // border-top: 2px solid #f4f4f4;
  box-sizing: border-box;
}
.service-wrap {
  font-style: normal;
  padding-bottom: 64px !important;
  overflow-y: auto;
  .account_content {
    display: block;
    width: 980px;
    font-size: 0;
    align-items: flex-end;
    box-sizing: border-box;
    // margin-bottom: 12px;
    .card-wrap {
      // flex: 1;
      // @include flex;
      display: inline-block;
      padding: 28px 30px 28px 28px;
      @include whiteBox;
      width: 485px;
      margin-bottom: 10px;
      &:first-child {
        margin-right: 10px;
      }
      // &:last-child {
      //   margin-left: 12px;
      // }
    }
    .coupons-count {
      flex: 1;
      margin-left: 28px;
      color: $color-orange;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
    .first-child {
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
      font-weight: 500;
    }
    .gold-icon {
      width: 24px;
      margin-left: 28px;
    }
    .balance-count {
      font-weight: 500;
      font-size: 24px;
      line-height: 26px;
      color: $color-gray-1;
      margin-left: 7px;
      flex: 1;
      text-align: left;
    }
    .service-btn {
      width: 80px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      border-radius: 50px;
      background: $color-yellow;
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: $color-gray-1;
      margin-left: 32px;
      &:active {
        background: #f5cd23;
      }
    }
  }
  .service-header {
    width: 100%;
    text-align: left;
    display: flex;
    margin-bottom: 36px;
    p {
      cursor: pointer;
      margin: 0 20px 0 0;
      font-weight: 500;
      font-size: 22px;
    }
    .selectTab {
      color: #ffa040;
    }
  }
  .add-service {
    height: 30px;
    display: flex;
    justify-content: flex-start;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    margin: 15px 0;
  }
  .explanation-area {
    span {
      @include flex();
      font-size: 0;
      cursor: pointer;
    }
  }

  .hide-btn {
    border: none;
    cursor: unset;
  }
  .service-msg {
    height: 61px;
    border-bottom: 1px solid $color-split;
    margin: 0 28px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: $color-gray-3;
    &.is-Diabond {
      .service-msg-1 {
        width: 358px;
      }
      .service-msg-2 {
        width: 134px;
      }
      .service-msg-3 {
        width: 134px;
      }
      .service-msg-4 {
        width: 158px;
      }
      .service-msg-5 {
        width: 140px;
      }
    }
    .service-msg-1 {
      width: 358px;
    }
    .service-msg-2 {
      width: 134px;
    }
    .service-msg-3 {
      width: 134px;
    }
    .service-msg-4 {
      width: 158px;
    }
    .service-msg-5 {
      width: 140px;
    }
  }
}
/deep/ .el-dialog {
  border-radius: 20px;
  .el-dialog__body {
    padding-top: 0;
  }
  .el-input.is-disabled .el-input__inner {
    background: #fff;
    color: #222c43;
    font-size: 20px;
    font-weight: 700;
  }
  .el-input__inner {
    border: none;
    border-radius: 80px;
    background-color: #e7e9ee;
    padding-left: 40px;
    margin: 0;
  }
  .el-button {
    border-radius: 100px;
    width: 120px;
    background-color: #e7e9ee;
    border: none;
  }
  .el-button + .el-button {
    background-color: #ffeb36;
  }
  .diamond-pay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .diamond-transition {
      display: flex;
      align-items: center;
      > span {
        display: flex;
        align-items: center;
      }
    }
    .diamond-pay-box {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
    .pay-num {
      margin: 10px 0;
      display: flex;
      align-items: center;
      .pay-num-item {
        font-size: 20px;
        font-weight: 600px;
        color: #f56c6c;
        padding-bottom: 2px;
      }
    }
    img {
      width: 24px;
      height: 24px;
    }
    .diamond-pay-box {
      .el-input {
        width: 150px;
        .el-input__prefix {
          top: 8px;
        }
      }
    }
  }
}
.balance-statement {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: #999999;

  & > div {
    flex: 1;
  }
  .clearing {
    display: flex;
    justify-content: center;
    padding-left: 20px;
    img {
      position: relative;
      top: 1px;
    }
  }
  .price-count {
    margin-top: 1px;
    line-height: 22px;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: flex;
    justify-content: center;
  }
}
.realizetion {
  font-size: 28px !important;
  line-height: 39px;
  font-weight: normal !important;
}
.withdrawal-btn {
  background: #ff891e !important;
  color: #ffffff !important;
}
</style>
